import React, {forwardRef, useContext, useEffect, useState} from "react";
import {useNumericMenu} from "react-instantsearch-hooks-web";
import {forEach} from "lodash";
import Slider from "rc-slider";
import 'rc-slider/assets/index.css'
import FilterContext from "../../Context/FilterContext";

const NumericRange = forwardRef((props, ref) => {
    const { setLoading } = useContext(FilterContext)

    const { attribute, activeSlider, setActiveSlider, defaultValue } = props
    const { items, refine } = useNumericMenu(props);

    const [marks, setMarks] = useState({})
    const [value, setValue] = useState(0)

    const onChange = value => {
        setLoading(true)
        setValue(value)
        setActiveSlider(attribute)
    }

    useEffect(() => {
        const values = {}

        forEach(items, (item, key) => {
            values[key] = {
                label: item.label,
                value: item.value
            }
        })

        setMarks(values)
    }, [])

    useEffect(() => {
        if (Object.keys(marks).length === 0) return;

        setValue(props.defaultValue ?? Object.keys(marks).length - 1)
    }, [marks])

    useEffect(() => {
        if (activeSlider === undefined) return;
        if (activeSlider === attribute) return;
        setValue(defaultValue ?? Object.keys(marks).length - 1)
    }, [activeSlider])

    useEffect(() => {
        if (Object.keys(marks).length === 0) return;
        setLoading(true)
        setTimeout(() => refine(marks[value].value), 250)
    }, [value])

    return (
        <Slider
            {...props}
            onChange={onChange}
            min={0}
            max={items.length - 1}
            value={value}
            marks={marks}
        />
    )
})

export default NumericRange